export default __webpack_public_path__ + "static/media/blog03.a7408bc2.png";